module.exports = __webpack_public_path__ + "img/9af943484331834b0544558036abad2b.png";